import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, TextField, Switch } from '@mui/material'

import LanguageContext from "../../../contexts/LanguageContext"
import { useTexte } from "../../../contexts/FormeAdresseContext"
import UserContext from "../../../contexts/UserContext"

import SuperAdminContext from "../../../contexts/SuperAdminContext"


import { TopBar, BottomBar, CenterContainer, BlocIllustre, ImageCarree, LARGEUR_CONTENU, LARGEUR_QUESTION, LARGEUR_CARTE_TEXTE, LARGEUR_CARTE_ILLUSTREE, COLONNE_ILLUSTREE, LARGEUR_LECTURE, LARGEUR_CHAMP, sansBlancsAutour, IMAGE_PLEINE, imagePleine, coteDeLImage, DEGRADE_PANNEAU, useApercuPleineHauteur , FOND_BANDE_BASSE, LARGEUR_CARTES, BandeReponse, useRaccourciClavier, TOUCHE_COMMANDE, ROGNE_HAUT, RESERVE_ACCENTS, retraitPlanche, HAUTEUR_PLANCHE, FENETRE_COURTE } from "./FormatsHelpers"
import { APERCU_EDITO } from "./apercu"

import EditableField from "./EditableField"
import EditableButton from "./EditableButton"

import EditorPopover from "../../ui/Admin/Formations/EditorPopover"

/* ⛔ LE SEUIL DE VALIDATION, EN UN SEUL ENDROIT. Il valait `length <= 3` en
   dur a deux endroits, sans qu'aucun texte ne l'annonce a l'apprenant : le
   bouton restait gris sans explication. La constante sert MAINTENANT a la fois
   au test et au libellé, donc les deux ne peuvent plus diverger. */
const MIN_CARACTERES = 4
/* ⛔ B76 (decision d'Hicham du 02/10/2026) : la saisie d'une ligne reste
   limitee a 30 caracteres, mais l'apprenant le VOIT. Avant, le 31e caractere
   etait refuse sans un mot (35 tapes, 30 enregistres). Le compteur apparait
   dans le champ des que la limite approche, pour ne pas charger l'ecran. */
export const LIMITE_UNE_LIGNE = 30
export const compteurVisible = (longueur) => longueur >= LIMITE_UNE_LIGNE - 10

const FormatInputTexte = ({ actFormation, actIndex, format, setViewPlanCours, viewPlanCours, onlyContent, isEditor, sequenceSubMenu, setSequenceSubMenu }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)
  /* Tutoiement / vouvoiement selon la cible du module (07/10/2026,
     contexts/FormeAdresseContext.js). */
  const t = useTexte()

  const { manageFormatResponse, manageSlide } = useContext(UserContext)

  let superAdminContext = null
  if (isEditor) {
    superAdminContext = useContext(SuperAdminContext)
  }

  /* Meme regle que les ecrans de texte et de quiz : la mise en page ne doit pas
     dependre de la presence d'une image. 19 des 19 ecrans de saisie des six
     modules de Nawal sont sans image ; sans cette regle, leur question se
     centrait quand celle de l'ecran voisin se ferrait a gauche.
     Ce format n'avait jamais recu le traitement pleine hauteur : il le recoit
     ici, pour les memes raisons et par les memes valeurs. */
  const pleineHauteur = useApercuPleineHauteur() && format?.image?.type !== "contain"
  /* Le cote de l'image alterne d'un ecran a l'autre, regulierement. */
  /* L'alternance n'a de sens que s'il y a une image a faire alterner. Sans
     image, on garde l'ancrage a gauche, toujours le meme. */
  /* ⛔ 01/10/2026 — UN SEUL PREDICAT POUR « Y A-T-IL UNE IMAGE ? », et c'est
     l'ADRESSE. `FormatQuizz` l'a appris le 21/09 et le documente : l'editeur
     ecrit `{link:"", type:"cover"}` des que l'admin VIDE le champ d'URL, donc
     l'objet existe alors que l'image n'existe pas. Ce fichier testait encore
     l'objet. Avec les deux moities (30/09), l'ecart coutait plus cher qu'avant :
     l'ecran passait pour illustre, le contenu partait dans la moitie droite et
     la moitie gauche restait VIDE.
     Releve en base locale le 01/10 : 0 ecran dans cet etat aujourd'hui, donc
     rien ne change a l'ecran. C'est un piege arme, pas un defaut actif — il se
     declencherait le jour ou Nawal vide une adresse.
     ⚠️ Les interrupteurs de l'EDITEUR gardent `format?.image` : eux demandent
     bien « ce format a-t-il un bloc image ? », pas « y a-t-il une image ». */
  const aUneImage = !!format?.image?.link
  const cote = !pleineHauteur ? null : (aUneImage ? coteDeLImage(actIndex) : "droite")
  const panneau = pleineHauteur && !aUneImage
  const commeIllustre = aUneImage || panneau
  /* 30/09/2026 — fiche de Nawal, points 5, 7 et 8. Les deux moities de la
     planche n'existent QUE s'il y a une image (voir `BlocIllustre`) : un ecran
     sans image garde sa colonne centree sur la planche. `commeIllustre` ne
     suffit donc pas, il est vrai aussi pour le panneau. */
  const enMoities = aUneImage

  /* ⛔ 01/10/2026 — « ↵ POUR VALIDER », ET SEULEMENT LA OU LA TOUCHE EST LIBRE.
     Point 3 d'Hicham. Les planches 02, 03, 04 et 05 portent toutes le repere.
     Mais sur une ZONE DE TEXTE, la touche Entree sert deja : elle fait un
     retour a la ligne. La brancher sur la validation ferait partir la reponse
     d'un apprenant au milieu de sa phrase — une perte de donnee silencieuse,
     et la pire espece.
     On la branche donc sur le champ A UNE LIGNE, ou Entree n'a aucun autre
     emploi, et on ne DESSINE le repere que la ou il fonctionne : un repere qui
     ment est pire que pas de repere.
     ⛔ EN SUSPENS POUR HICHAM : la planche 03 et la planche 05 (zone de texte)
     dessinent « ↵ pour valider ». Deux conventions possibles — Entree valide et
     Maj+Entree fait le retour a la ligne, ou Cmd/Ctrl+Entree valide. Les deux
     changent la facon d'ecrire une reponse longue : ca se tranche avec Nawal,
     pas ici. */
  const estUneLigne = format?.answers?.type !== "textarea"
  const peutValider = () => response.length >= MIN_CARACTERES && isAlreadyAnswer !== true
  /* Le clic et la touche passent par LA MEME fonction : deux chemins pour le
     meme geste finissent toujours par diverger. */
  const valider = () => {
    /* ⛔ B72 (02/10/2026) — ECRAN DEJA REPONDU : ON AVANCE, SANS REECRIRE.
       Rouvert par le plan, l'ecran affiche la reponse, champ desactive, et
       « Valider » actif : la garde `peutValider` refusait (deja repondu) et le
       clic ne faisait RIEN, Entree non plus. L'apprenant devait rouvrir le plan
       et « Reprendre ». Comme le quiz deja repondu : on passe a la suite. */
    if (isAlreadyAnswer) { manageSlide(1); return }
    if (!peutValider()) return
    manageFormatResponse(format, [{ key: 'isDone', value: true }, { key: 'userChoice', value: response }])
    manageSlide(1)
  }
  useRaccourciClavier(isEditor !== true && onlyContent !== true, (e) => {
    if (e.key !== "Enter") return
    /* ⚠️ ON N'APPELLE PAS `saisieEnCours` ICI, et c'est VOULU : le geste attendu
       est precisement « je tape ma reponse, j'appuie sur la touche ». C'est le
       seul endroit du code ou le champ a le droit de laisser passer Entree. */
    if (estUneLigne) {
      /* A une ligne, Entree vaut SEULE : une combinaison ne doit pas valider
         une deuxieme fois par un autre chemin. */
      if (e.metaKey || e.ctrlKey || e.altKey) return
    } else {
      /* En zone de texte, Entree seule reste un retour a la ligne. */
      if (!e.metaKey && !e.ctrlKey) return
    }
    e.preventDefault()
    valider()
  }, !estUneLigne)
  /* ⛔ 01/10/2026 (soir) — LA ZONE DE TEXTE A SON RACCOURCI, ET IL EST ANNONCE.
     Decision d'Hicham : « Oui mais il faut le preciser peut-etre, comme on
     valide. » Donc pas de raccourci muet, et aucun ecran sans sa consigne.
     A UNE LIGNE : Entree, comme la planche (node 3:60551).
     EN ZONE DE TEXTE : ⌘+Entree (Ctrl ailleurs), parce qu'Entree seule doit
     rester un retour a la ligne — sinon la reponse d'un apprenant part au
     milieu de sa phrase, et c'est une perte silencieuse.
     ⚠️ LA PLANCHE DESSINE « ↵ pour valider » LA AUSSI (nodes 3:60551 et
     3:121027). On s'en ecarte SCIEMMENT : elle ne dit pas ce que fait Entree
     dans un champ multiligne, et le seul rendu fidele serait dangereux. Le
     cabochon supplementaire est donc DEDUIT, pas releve. */
  const reperesClavier = [{
    touche: estUneLigne ? "entree" : [TOUCHE_COMMANDE, "entree"],
    libelle: languageValues?.formation?.toucheValider?.[actLanguage],
  }]
  /* ⛔ PLUS DE PANNEAU SUR LES ECRANS SANS IMAGE (Hicham, 09/09 : « c'est
     moche quand il y a que du texte »). Le degrade bleu nuit occupait la
     moitie de l'ecran en face d'une colonne de 520 px : sur un ecran qui ne
     porte QUE du texte, cela faisait une page a moitie vide et a moitie
     sombre. Il venait pourtant de l'ancien lecteur — mais chez lui il
     PORTAIT les propositions du quiz ; vide, il ne raconte rien.
     Ce qu'on garde, c'est l'ANCRAGE : le texte reste au meme endroit que sur
     les ecrans illustres, ce qui etait tout l'objet de la regle. Ce qu'on
     rend, c'est la LARGEUR : la colonne passe a la largeur de lecture. */
  const imageDuFormat = !aUneImage ? null
    : pleineHauteur
      ? <Box sx={{ ...imagePleine(cote), backgroundImage:"url(\""+format?.image?.link+"\")", backgroundSize:"cover" }} />
      : <ImageCarree lien={format?.image?.link} type={format?.image?.type} bordABord />

  const [isAlreadyAnswer, setIsAlreadyAnswer] = useState(false)
  const [response, setResponse] = useState("")
  useEffect(() => {
    if (format?.isDone) {
      setIsAlreadyAnswer(true)
      if (format?.userChoice) {
        setResponse(format?.userChoice)
      } else {
        setResponse("")
      }
    } else {
      setIsAlreadyAnswer(false)
      setResponse("")
    }
  }, [format])

  /* Le champ de saisie, extrait pour etre place SOIT dans la colonne (ecran a
     image), SOIT dans la bande chaude (ecran sans image, cas courant : Figma).
     Toute la logique de saisie est preservee (value/onChange/disabled/maxLength). */
  const champSeul = (
    <TextField
      fullWidth
      multiline={format?.answers?.type === "textarea" ? true : false}
      rows={5}
      name="response"
      type="text"
      value={response}
      variant="outlined"
      placeholder={isEditor ? "" : (languageValues?.reponseMinimum?.[actLanguage] || t(languageValues?.formation?.yourAnswer))}
      disabled={isAlreadyAnswer}
      inputProps={{ maxLength: format?.answers?.type !== "textarea" ? LIMITE_UNE_LIGNE : "unset" }}
      InputProps={estUneLigne && !isAlreadyAnswer && compteurVisible(response.length) ? {
        endAdornment: (
          <Box component="span" data-compteur-caracteres aria-live="polite"
            sx={{ flex:"0 0 auto", marginLeft:"10px", fontSize:"13px", whiteSpace:"nowrap",
              color: response.length >= LIMITE_UNE_LIGNE ? "#C0392B" : "#8A8480" }}>
            {response.length}/{LIMITE_UNE_LIGNE}
          </Box>
        ),
      } : undefined}
      onChange={(e) => {
        setResponse(e.target.value);
      }}
      sx={{
        width:"100%",
        /* Point 8 : deux largeurs, pas une. */
        maxWidth: format?.answers?.type === "textarea" ? LARGEUR_CHAMP.textarea : LARGEUR_CHAMP.uneLigne,
        /* Figma : bordure claire #BEBEBE (au lieu du noir MUI par defaut) ;
           bordure noire seulement une fois la reponse validee. !important pour
           passer devant la regle fieldset noire du theme. */
        /* Angles droits : le cadre 3:60548 n'a pas de rayon (0), MUI en pose 4
           sur la racine ET sur le cadre de bordure. Constate par le comparateur
           aux trois paliers (3:60548, 3:60575, 3:60620). */
        "& .MuiOutlinedInput-notchedOutline": { borderColor: (isAlreadyAnswer ? "#000000" : "#BEBEBE") + " !important", borderRadius:0 },
        "& .MuiInputBase-root" : {
          /* 70 px a Desktop ET a Tablet (3:60548, 3:60575), 55 en Mobile
             (3:60620). Le code posait 60 en Tablet et 75 en Desktop. */
          /* Zone de texte : 200 px a Desktop et Tablet (3:80677, 3:80708), 150
             en Mobile (3:80757). L'autosize de MUI, fige a 5 lignes, donnait
             155 et 132. */
          height: estUneLigne ? ["55px", "70px", "70px", "70px"] : ["150px", "200px", "200px", "200px"],
          borderRadius:0,
          /* Une ligne : 20 px (L15). Zone de texte : 10 px en haut, en bas et a
             droite, ou passe la barre de defilement, 20 a gauche (15 en Mobile)
             — cadres 3:80677 et 3:80757. */
          padding: estUneLigne ? "20px" : ["10px 10px 10px 15px", "10px 10px 10px 20px", "10px 10px 10px 20px", "10px 10px 10px 20px"],
          alignItems: estUneLigne ? undefined : "stretch",
          width:"100%",
          /* ⚠️ RELU DANS FIGMA (21/09/2026, lot 3c). Jeton
             « Text/Desktop/Body/Large » : 20 px a Desktop et Tablet (3:60549),
             16 px en Mobile (3:60621). Le code posait 18 px PLAT aux trois
             paliers, donc trop petit en grand et trop gros en petit. */
          /* Zone de texte : 18 px (3:80679, 3:80710), 16 en Mobile (3:80759). */
          fontSize: estUneLigne ? ["16px", "20px", "20px", "20px"] : ["16px", "18px", "18px", "18px"],
          /* Interligne 1,15, jeton « Text/Desktop/Body/Medium » (3:80679).
             MUI impose 1,4375em sur InputBaseRoot : la zone de texte affichait
             25,9 px par ligne au lieu de 20,7, soit 25 % de trop, et perdait
             pres de deux lignes visibles sur les 8,7 dessinees. */
          lineHeight:"1.15",
          background:"white",
        },
        "& .MuiInputBase-input" : {
          padding: "0px",
          /* MUI herite d'un interlettrage de 0,00938 em (body1) ; la planche
             n'en a aucun (3:60549, letterSpacing 0). */
          letterSpacing:0,
          color:"black", // L16 : texte noir pendant la saisie
        },
        /* ⛔ ZONE DE TEXTE : ELLE REMPLIT SON CADRE, ET ELLE MONTRE QU'ELLE DEFILE
           (02/10/2026). La planche dessine dans le champ une piste de 2 px
           (#D9D9D9) et un curseur noir, 10 px sous le haut et 12 px avant le bord
           droit (3:80681, 3:80682). L'autosize de MUI ecrit
           `overflow: hidden` EN LIGNE tant que le texte tient dans ses lignes :
           la piste n'apparaissait jamais sur un champ court ou vide. La barre est celle du navigateur, habillee
           comme la planche ; `scroll` la garde visible, piste comprise, et le
           curseur apparait des que le texte deborde. `!important` pour passer
           devant le style en ligne de l'autosize. */
        ...(estUneLigne ? {} : {
          "& .MuiInputBase-inputMultiline:not([aria-hidden])" : {
            height:"100% !important",
            overflowY:"scroll !important",
            boxSizing:"border-box",
            paddingTop:["10px", "15px", "15px", "15px"],
            paddingRight:"10px",
            /* ⚠️ `scrollbarColor: auto`, et c'est indispensable : la propriete
               S'HERITE, et le bloc defilant qui porte le champ en pose une
               (BLOC_DEFILANT). Des qu'elle a une valeur, Chrome ignore
               `::-webkit-scrollbar` et reprend sa barre systeme, en
               surimpression et sans place reservee. */
            scrollbarColor:"auto",
            scrollbarWidth:"auto",
            "&::-webkit-scrollbar" : { width:"2px" },
            "&::-webkit-scrollbar-track" : { background:"#D9D9D9" },
            "&::-webkit-scrollbar-thumb" : { background:"#000000" },
          },
        }),
        /* ⚠️ LE TEXTE D'INVITE ETAIT ILLISIBLE. MUI rend `::placeholder` en
           `currentColor` a `opacity: 0.42` (InputBase.js:98-100), ce qui donnait
           un gris ~#949494, soit environ 3,0:1 sur blanc — sous le seuil
           d'accessibilite. Figma pose rgba(10,10,11,0.7) sur les TROIS noeuds
           interroges (3:60549, 3:80679, 3:60621). On neutralise donc l'opacite
           de MUI et on pose la couleur en clair. */
        "& .MuiInputBase-input::placeholder" : {
          color:"rgba(10, 10, 11, 0.7)",
          opacity: 1,
        },
      }}
    />
  )

  /* ⛔ L'INSTRUCTION EST DANS LE CHAMP, PAS A COTE (Hicham, 22/09/2026).
     Premiere version : une ligne sous le champ. Elle s'est posee A DROITE du
     champ, sur la meme rangee, et ca se voyait — le conteneur est une rangee
     flex, un frere s'y range horizontalement.
     L'instruction devient donc le texte d'invite du champ lui-meme. Elle dit ce
     qu'on attend au lieu de compter des caracteres : « au moins une phrase »
     se comprend sans calcul, et le seuil technique reste MIN_CARACTERES. */
  const champ = champSeul

  return (
    <Box sx={{
      display:"flex",
      flexDirection:"column",
      /* ⚠️ `100vh` vaut la hauteur de la FENETRE, jamais celle d'un conteneur.
         Un apercu qui simule 982 px dans un panneau aurait donc affiche un ecran
         calibre sur la vraie fenetre. La variable `--hs-hauteur-ecran` n'est
         definie QUE par le panneau d'apercu ; partout ailleurs le repli `100vh`
         s'applique et rien ne change. Une variable CSS plutot qu'un prop : neuf
         signatures de composants restent intactes, et un format rendu hors du
         lecteur se comporte correctement sans qu'on ait pense a le lui dire. */
      height:onlyContent?"100%":"var(--hs-hauteur-ecran, 100vh)",
      /* ⛔ LE FORMAT DEVIENT SON PROPRE REFERENTIEL DE MESURE (08/09/2026).
         Nawal voit « de grosses differences » entre l'apercu de l'admin et la
         vue apprenant. Cause : l'apercu ne rend pas l'ecran a la taille de la
         fenetre. `ScaleThumbForm` le rend dans une boite FIXE de 1500 x 1000,
         puis la reduit par un `transform: scale()`. Or `vw` et `vh` se
         calculent sur la FENETRE, jamais sur cette boite : les proportions
         divergeaient donc des deux cotes, sans qu'aucun reglage puisse les
         reconcilier — ce sont deux referentiels differents.
         En declarant ce conteneur, les unites `cqw`/`cqh` employees plus bas se
         mesurent sur LUI. Dans le lecteur il occupe la fenetre : le rendu ne
         bouge pas d'un pixel. Dans l'apercu il fait 1500 x 1000 : le rendu
         devient fidele. */
      containerType:"size",
      overflow:"hidden",
      /* ⛔ PAS DE GAP RACINE (22/09). La planche colle le contenu au bandeau :
         le cadre de contenu commence exactement a y=75, et la bande basse est
         adjacente elle aussi. Ces 10 px repoussaient tout l'ecran vers le bas et
         comptaient pour 10 des 22 px de decalage mesures sur la pastille. */

      /* ⛔ L'ANCRE DU PANNEAU. Un bloc en `position: absolute` sans ancetre
         positionne se cale sur la FENETRE : il passerait sous le bandeau du
         haut et sous celui du bas, rendant la pastille illisible et « Valider »
         a moitie cache. C'est arrive le 08/09 sur les ecrans de texte. */
      position: APERCU_EDITO ? "relative" : "static",
    }}>
      { /* EDITOR ADMIN */}
      {isEditor &&
        <EditorPopover
          open={sequenceSubMenu}
        >
          <Box sx={{marginBottom:"2px", fontWeight:"bold"}}>Champ réponse</Box>
          <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
            <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
              <Switch
                sx={{marginLeft:"-5px"}}
                checked={format?.answers?.type === "textarea"?true:false}
                onChange={(e) => {
                  if (e.target.checked) {
                    superAdminContext?.onSequenceChange(
                      'answers',
                      { type: 'textarea' },
                      superAdminContext?.adminPlayerIndexes
                    )
                  } else {
                    superAdminContext?.onSequenceChange(
                      'answers',
                      { type: 'input' },
                      superAdminContext?.adminPlayerIndexes
                    )
                  }
                }}
                size="small"
                color="warning"
              />
              Textarea
            </Box>
          </Box>
          <Box sx={{marginTop:"10px", marginBottom:"2px", fontWeight:"bold"}}>Image</Box>
          <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
            <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
              <Switch
                sx={{marginLeft:"-5px"}}
                checked={format?.image?true:false}
                onChange={(e) => {
                  if (e.target.checked) {
                    superAdminContext?.onSequenceChange(
                      'image',
                      { link: 'https://video.thelab.risinguparis.com/brain.svg', type: 'contain' },
                      superAdminContext?.adminPlayerIndexes
                    )
                  } else {
                    superAdminContext?.onSequenceChange(
                      'image',
                      null,
                      superAdminContext?.adminPlayerIndexes
                    )
                  }
                }}
                size="small"
                color="warning"
              />
              Afficher une image
            </Box>
            {format?.image &&
              <>
                {/* ⛔ 01/10/2026 — L'INTERRUPTEUR « ELARGIR L'IMAGE » EST RETIRE.
                    Decision d'Hicham : « Image entiere toujours », puis « oui
                    retire, on verra avec Nawal ce qu'elle prefere ».
                    Il choisissait entre `cover` (remplir, donc rogner) et
                    `contain` (tout voir). L'image est desormais TOUJOURS
                    entiere : il ne decidait plus de rien. Un interrupteur qui ne
                    fait rien est pire qu'un interrupteur absent — Nawal l'aurait
                    actionne en cherchant un effet.
                    ⚠️ LA DONNEE N'EST PAS TOUCHEE : `image.type` reste en base
                    sur les ecrans existants, simplement plus lu pour le
                    rognage. Si la decision revient, c'est ce bloc qu'on remet,
                    et rien a remigrer. */}
                <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
                  <Box>
                    Url&nbsp;:
                  </Box>
                  <Box sx={{flex:1}}>
                    <input
                      value={format?.image?.link}
                      style={{width:"100%"}}
                      onChange={(e) => {
                        superAdminContext?.onSequenceChange(
                          'image',
                          { link: e.target.value, type: format?.image?.type },
                          superAdminContext?.adminPlayerIndexes
                        )
                      }}
                    />
                  </Box>
                </Box>
              </>
            }
          </Box>
        </EditorPopover>
      }
      { /* END EDITOR ADMIN */}

      <TopBar
        actFormation={actFormation}
        actIndex={actIndex}
        setViewPlanCours={setViewPlanCours}
        viewPlanCours={viewPlanCours}
        onlyContent={onlyContent}
      />
      <CenterContainer
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={onlyContent}
        /* ⛔ L9 EST REMPLACEE PAR LE FIGMA DU 17/09, ET C'EST TRACE.
           L9 (Valentin, 13/05/2026) disait « Retirer l'element au-dessus des
           questions ». C'est une preference purement VISUELLE, sans regle de
           comportement, du meme auteur que les planches, et anterieure de
           quatre mois. Les planches actuelles montrent la pastille de
           sous-chapitre sur CHAQUE ecran de question — quiz 3:282231,
           questionnaire 3:241965, saisie 3:40519, quiz illustre 4:559.
           Regle appliquee : a preference visuelle egale, la source la plus
           recente du meme auteur l'emporte. */
        noPartInfos={false}
        /* Retrait du haut, palier par palier : 80 en Mobile (planche 02,
           3:60611), 160 en Tablet et 120 en Desktop (les valeurs par defaut). */
        /* Tablet 162 : la zone haute part a y=77 sur les planches 02 et 03
           (3:60566), avec 160 de marge ; la pastille tombe a 237.
           ⛔ 04/10/2026 — A LA HAUTEUR DE LA PLANCHE SEULEMENT (1194). Fixe, ce
           retrait tombait aussi sur un telephone en paysage (palier Tablet par
           la largeur, 360 px de haut) : le bouton Valider sortait de l'ecran de
           53 px, et rien ne defilait pour le rattraper (verifie au banc, 800x360
           et 667x375, deja vrai sur LAB). Meme regle que le quiz (PD-23). */
        /* Ecran illustre : `pastilleAvecImage` decide (RETRAIT_ILLUSTRE). */
        retraitHaut={[80, retraitPlanche(32, 162, HAUTEUR_PLANCHE.tablette), 120, 120]}
        cote={cote}
              pastilleDansColonne
              pastilleAvecImage={enMoities}
      >
        {({ pastille }) => (<>
        {/* Points 8 et 9. L'image suit la regle commune : carree, 28 %, alignee
            en haut et en bas avec le contenu. Le champ de saisie a DEUX largeurs
            distinctes selon sa variante — il faisait 62 % dans les deux cas,
            soit plus du double de la largeur prevue en mode une ligne.
            Le `margin: auto 0` qui centrait le bloc verticalement est retire :
            c'est le meme defaut que le point 6, en local. */}
        <BlocIllustre
          pastille={pastille}
          remplitTablette
          image={imageDuFormat}
          horsFlux={cote}
        >
          <Box sx={{
            /* ⛔ 30/09/2026 — LA COLONNE PREND TOUTE SA MOITIE (821), ET C'EST
               CE QUI CORRIGE LA BANDE. La planche 05 pose la bande a 821 x 400
               dans la colonne de droite (node 3:121019) — c'est ecrit vingt
               lignes plus bas depuis le 22/09. Mais la colonne, elle, valait 741 :
               la bande recevait `largeur="100%"` et tombait donc a 741, mesuree
               a 646 -> 1387 au lieu de 691 -> 1512. Le nombre etait connu, c'est
               la colonne qui le dementait.
               La colonne prend desormais sa moitie entiere ; l'enonce, lui, garde
               ses 741 (node 3:100876) et se centre dedans, donc a 731. */
            width: enMoities ? "100%" : (commeIllustre ? LARGEUR_CONTENU : "100%"),
            /* ⚠️ AUX DEUX GRANDS PALIERS SEULEMENT. Pose sans palier, ce centrage
               s'appliquait aussi en Tablet, ou la composition est empilee et ou
               les moities n'existent pas : le releve avant/apres a vu bouger
               `input-textarea-image` a 834 px, seul ecart non voulu du lot. */
            alignItems: enMoities ? [null, null, "center", "center"] : undefined,
            /* ⚠️ LA COLONNE PORTE LE TITRE : elle suit donc la largeur d'enonce
               de la planche (1000), et non l'ancien 720 qui n'a aucune
               contrepartie Figma. La carte, elle, se plafonne plus bas. */
            maxWidth: commeIllustre ? "100%" : LARGEUR_QUESTION,
            display:"flex",
            flexDirection:"column",
            /* ⛔ 04/10/2026 — EMPILE ET ILLUSTRE, LA COLONNE NE ROGNE PAS. Sa bande
               va d'un bord a l'autre par des marges negatives (debordeEmpile) :
               une colonne en `overflow-x: hidden` la recoupait a ses gouttieres,
               et l'on voyait 20 / 40 px blancs de chaque cote (relecture du
               04/10, comparateur muet : il ignorait le rognage). `visible` sur
               les deux axes — un seul axe visible n'existe pas en CSS. La page,
               elle, defile (CenterContainer). */
            overflowX: aUneImage ? ["visible", "visible", "hidden", "hidden"] : "hidden",
            overflowY: aUneImage ? ["visible", "visible", "auto", "auto"] : "auto",
            boxSizing:"border-box",
            /* En fenetre courte, deux colonnes : la colonne rogne et defile
               comme aux grands paliers (comportement de LAB). */
            ...(commeIllustre ? { [FENETRE_COURTE]: { ...COLONNE_ILLUSTREE[FENETRE_COURTE], ...(aUneImage ? { overflowX:"hidden", overflowY:"auto" } : {}) } } : {}),
            ...RESERVE_ACCENTS,  /* place au-dessus de l'enonce rogne : voir FormatsHelpers */
            /* ⚠️ DEUX LARGEURS. Face a une image, la colonne tient dans sa moitie
               (520 px). Sans image, elle n'a plus de voisine : la maintenir a
               520 px laissait un ecran a moitie vide, ce qu'Hicham a trouve
               moche « quand il y a que du texte ». Elle passe alors a la
               largeur de lecture, en gardant le meme bord gauche : le texte ne
               bouge pas, il respire. */
            ...(pleineHauteur ? { width: format?.image ? ["100%", "100%", "min(38cqw, 520px)", "min(38cqw, 520px)"] : ["100%", "100%", "min(52cqw, 720px)", "min(52cqw, 720px)"], maxWidth:"100%",
                            position:"relative", zIndex:1 } : {}),
          }}>
            <EditableField
              field={sansBlancsAutour(format?.questions)}
              type="questions"
              isEditor={isEditor}
              sx={{
                color:"text.black",
                /* ⚠️ ECHELLE DU TITRE RELUE DANS FIGMA (21/09/2026, lot 3a).
                   Jeton nomme « Text/Desktop/Heading/H1 » : Questrial Regular,
                   42 px, interligne 1,15, letterSpacing 0. Noeuds 3:302257
                   (Desktop), 3:282076 (Tablet), 3:282135 (Mobile, 26 px / 1,25).
                   Le 46 px du palier lg etait estime : la planche s'arrete a 42.
                   L'interligne n'etait declare NULLE PART, donc le navigateur
                   retombait sur `normal`, soit environ 1,15 a 1,2 selon la
                   police. On le pose explicitement. */
                /* 04/10/2026 : 38 px sur les planches ILLUSTREES aux grands
                   paliers (3:100877, 3:121017), ou l'enonce n'a que 741 px. */
                fontSize: aUneImage ? ["26px", "42px", "38px", "38px"] : ["26px", "42px", "42px", "42px"],
                lineHeight:["1.25", "1.15", "1.15", "1.15"],
                ...ROGNE_HAUT,  /* haut des capitales, comme la maquette : voir FormatsHelpers */
                textAlign:"center", // Lot B : titre centre meme avec image (frames « Claude »)
                /* ⛔ 01/10/2026 — L'ENONCE GARDE SES 741, ET LE COMMENTAIRE DE LA
                   COLONNE LE PROMETTAIT DEJA SANS QUE RIEN NE LE TIENNE.
                   Point 5 d'Hicham (« c'est pas aligne le carre de texte et
                   tout »). Depuis que la colonne prend sa moitie entiere, elle
                   porte `alignItems:center` : un enfant sans largeur s'y reduit
                   donc a SON TEXTE. Mesure a 1512 sur `input-textarea-image` :
                   titre a x=813 large de 577, la ou la planche 05 le pose a
                   x=731 large de 741 (node 3:121016). Il paraissait rentre par
                   rapport au cadre de saisie, qui commence lui a 751.
                   Centre dans les 821 de la moitie, un bloc de 741 tombe a 731 :
                   c'est la moitie qui le place, aucune valeur en dur. */
                ...(enMoities ? { width: LARGEUR_CONTENU, maxWidth:"100%" } : {}),
              }}
            />
            {/* Sous-consigne grise sous la question.
                ⛔ 01/10/2026 : citait `8548-46759`, propre au fichier d'ARCHIVE.
                Noeud « Claude » : `3:121018` (planche 05, 650 de large a x=776,5).
                Relu par l'API : noir a 70 %, Questrial 20 px, interligne 30 —
                soit exactement ce que pose le code (`text.subTitle`, 20 px,
                interligne 1,5). */}
            {format?.subTitle &&
              <EditableField
                field={format?.subTitle}
                type="subTitle"
                isEditor={isEditor}
                sx={{
                  color:"text.subTitle",
                  /* ⚠️ CONSIGNE RELUE DANS FIGMA (21/09/2026, lot 3a). Jeton
                   « Text/Desktop/Body/Large » : 20 px, interligne 1,5, aux deux
                   grands paliers ; 15 px en Mobile (3:282136). Cinq formats
                   portaient cinq echelles differentes pour le MEME element. */
                  fontSize:["15px", "20px", "20px", "20px"],
                  lineHeight:"1.5",
                  textAlign:"center", // Lot B : titre centre meme avec image (frames « Claude »)
                  /* ⚠️ RECALE SUR LA PLANCHE (01/10/2026, nuit). La planche met
                     40 px entre la ligne de base de la question et le haut des
                     capitales de la consigne en Desktop et Tablet (3:60545 ->
                     3:60546, 3:60572 -> 3:60573), 20 en Mobile (3:60617 ->
                     3:60618). L'interligne non rogne du navigateur en mange une
                     partie : mesure au comparateur, il faut 20 px de marge pour
                     tomber sur 40, et 6,5 pour tomber sur 20. */
                  /* 04/10/2026 : 21,5 aux grands paliers illustres, ou l'enonce
                     passe a 38 px (son interligne non rogne mange moins). */
                  marginTop: aUneImage ? ["6.5px", "20px", "21.5px", "21.5px"] : ["6.5px", "20px", "20px", "20px"],
                  maxWidth:"650px",
                  /* Centree partout : empilee en Tablet, la colonne illustree
                     ne centre pas ses enfants, et la consigne partait a gauche
                     (comparateur, planche 04 Tablet, 3:100943 : 52 px). */
                  marginLeft:"auto", marginRight:"auto",
                }}
              />
            }
            {/* Ecran A IMAGE : le champ reste dans la colonne, sous la question.
                Ecran SANS image (cas courant) : le champ descend dans la bande
                chaude, plus bas — conforme au Figma. */}
            {/* ⚠️ L'ECRAN ILLUSTRE A UNE BANDE, LUI AUSSI (capture d'Hicham, 22/09).
                Le commentaire precedent affirmait le contraire et posait une
                simple barre du bas. La planche 05 dit l'inverse : son node
                3:121019 fait 821 x 400 dans la colonne de droite et contient le
                champ (3:121020, a y=30) ET la rangee de controles (3:121026, a
                y=320) — exactement la meme structure que la planche 02, dont le
                code avait deja tire la lecon pour l'ecran SANS image.
                Le champ descend donc dans la bande, et la barre du bas dupliquee
                disparait. */}
            {commeIllustre &&
              <BandeReponse
                calerEnBas={enMoities}
                reperes={reperesClavier}
                hauteur="400px"
                hauteurMin="400px"
                largeur="100%"
                /* Empile, la bande va d'un bord a l'autre (3:80836, 3:100944) ;
                   en Mobile, la hauteur de son contenu, comme sans image (175
                   pour une ligne, 3:80836 ; 270 pour la zone de texte). */
                debordeEmpile={aUneImage}
                /* 40 px entre le champ et les controles en Tablet (3:100944,
                   3:121088), 20 en Mobile (3:80836). */
                ecart={["20px", "40px", "40px", "40px"]}
                plancherMobile={estUneLigne ? "min(175px, 46cqh)" : "min(270px, 46cqh)"}
                /* Tablet illustre : la hauteur de son contenu (3:100944 : 220
                   pour une ligne), collee en bas. */
                plancherTablette={estUneLigne ? "min(220px, 46cqh)" : undefined}
                onlyContent={isEditor ? false : onlyContent}
                controles={
    <EditableButton
                isEditor={false}
                type="button"
                /* ⛔ POINT 1.3 DE LA FICHE V2. Le libelle etait celui saisi
                   dans le contenu, d'ou les « C'est parti ! » et « On
                   continue ? » qui trainaient depuis des annees. Il est
                   desormais CALCULE, et la regle ecrase le contenu :
                   le clic ENREGISTRE la reponse ecrite par l'apprenant.
                   Le champ de saisie libre est retire avec lui
                   (isEditor={false}) : tant qu'il existait, le libelle
                   rederivait au module suivant. */
                field={languageValues?.validate?.[actLanguage]}
                disabled={!isAlreadyAnswer && response.length < MIN_CARACTERES}
                sx={{}}
                onClick={valider}
              />
                }
              >
                {champ}
              </BandeReponse>
            }
          </Box>
        </BlocIllustre>
        </>)}
      </CenterContainer>
      {/* ⛔ UNE SEULE ZONE BASSE, ET C'EST CELLE DE LA PLANCHE.
          Cet ecran en avait DEUX empilees : sa bande maison, puis une
          `BottomBar` teintee par-dessous. Capture LAB a 1512x982 : une couture
          horizontale nette a y=890, la bande s'arretant la et la barre
          reprenant en dessous. Le node 3:40519 n'en montre qu'une, qui contient
          le champ ET la rangee de controles. On utilise donc le meme composant
          que le quiz et le questionnaire. */}
      {!commeIllustre &&
        <BandeReponse
                calerEnBas={enMoities}
          reperes={reperesClavier}
          hauteur="400px"
          hauteurMin="400px"
          /* Mobile, la hauteur que la planche donne a la bande : une ligne, champ
             55 + 20 + bouton 45 + marges 20 et 35 = 175 (3:60619) ; zone de
             texte, 270 (3:80756). Le plancher commun de 238 gonflait la
             premiere ; 175 aurait ecrase la seconde sur un ecran bas. */
          plancherMobile={estUneLigne ? "min(175px, 46cqh)" : "min(270px, 46cqh)"}
          /* Tablet : 400 px collee en bas, comme la planche (3:60574). */
          hauteurFixeTablette
          onlyContent={isEditor ? false : onlyContent}
          controles={
          <EditableButton
            isEditor={false}
            type="button"
            /* ⛔ POINT 1.3 DE LA FICHE V2. Le libelle etait celui saisi
               dans le contenu, d'ou les « C'est parti ! » et « On
               continue ? » qui trainaient depuis des annees. Il est
               desormais CALCULE, et la regle ecrase le contenu :
               le clic ENREGISTRE la reponse ecrite par l'apprenant.
               Le champ de saisie libre est retire avec lui
               (isEditor={false}) : tant qu'il existait, le libelle
               rederivait au module suivant. */
            field={languageValues?.validate?.[actLanguage]}
            disabled={!isAlreadyAnswer && response.length < MIN_CARACTERES}
            sx={{}}
            onClick={valider}
          />
          }
        >
          {champ}
        </BandeReponse>
      }
    </Box>
  )
}


export default FormatInputTexte
